var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.isShow,"width":"80vw"},on:{"update:visible":function($event){_vm.isShow=$event}}},[_c('iframe',{attrs:{"src":("user/login/protocol?type=" + _vm.type),"width":"100%","height":"500px","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }